import Vue from 'vue'
import VRefresh  from './refresh'

export default VRefresh




// WEBPACK FOOTER //
// ./src/components/refresh/index.js